import Modal from "react-bootstrap/Modal";
import React, { memo, useState } from "react";
import "./contactForm.css";
import Spinner from "react-bootstrap/Spinner";

function ContactForm({ modal, showModal }) {
  const [name, setName] = useState({ msg: "", type: "" });
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoader] = useState(false);
  const [error, setError] = useState("");
  const onSubmit = (e) => {
    setLoader(true);
    setError({ msg: "", type: "" });
    e.preventDefault();
    window.Email.send({
      Host: "smtp.elasticemail.com",
      Username: "mehthabbusiness@gmail.com",
      Password: "F973BCFB15253C1D254F59281D45AAF75999",
      To: "mehthabbusiness@gmail.com",
      From: "mehthabbusiness@gmail.com",
      Subject: "Message from Website",
      Body: `Name: ${name} \n Email: ${email} \n Message: ${message}`,
    }).then((message) => {
      if (message === "OK") {
        setError({
          msg: "Your Message was Send Successfully",
          type: "submit",
        });
        setLoader(false);
      } else {
        setError({ msg: "Oops! Something went wrong.", type: "error" });
        setLoader(false);
      }
    });
  };

  return (
    <Modal
      centered
      show={modal}
      dialogClassName="contact-content"
      backdrop="static"
    >
      <form onSubmit={onSubmit}>
        {/* <Modal.Header className="d-flex justify-content-center p-0 border-0">
                <div className="w-100" style={{transition:"0.5s all"}} >
                <img src="images/wave-before.jpg" alt="Mehthab Email"
                onLoad={(e)=>e.target.src= "/images/wave.jpg"}
                style={{width:'100%',objectFit:'contain',transition:"0.5s all"}}/>
                </div>
            </Modal.Header> */}
        <Modal.Body>
          <div className="container-fluid">
            <div className="row px-2">
              <div className="col">
                <div className="row">
                  <label className="mb-0 mt-2">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    onChange={(e) => setName(e.target.value)}
                    placeholder="James Bond"
                    required
                  />
                </div>
                <div className="row mt-4">
                  <label className="mb-0">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="jamesbond@007"
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                  />
                </div>
                <div className="row mt-4">
                  <label className="mb-0">Message</label>
                  <textarea
                    rows="3"
                    style={{ height: "100%" }}
                    className="form-control"
                    id="validationTextarea"
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="I have a mission for you 😉"
                    required
                  ></textarea>
                </div>
                <label
                  className={`${
                    error.type === "error" ? "text-danger" : "text-success"
                  } mt-2`}
                >
                  {error.msg}
                </label>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <button
            type="button"
            onClick={() => {
              showModal(false);
              setError({ msg: "", type: "" });
            }}
            className="btn btn-outline-primary py-2 px-4 ml-3"
          >
            Next Time
          </button>
          <button
            type="submit"
            disabled={loading || error.type === "submit"}
            className="btn btn-primary py-2 px-4 "
          >
            {loading ? (
              <span className="align-items-center d-flex">
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  className="mr-2"
                />
                Submiting
              </span>
            ) : (
              "Submit"
            )}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}

export default memo(ContactForm);
